
import { store }                from '../../index';
import { SET_COMPONENTS_STATE } from 'actions';
import { objType }              from 'types';

const handleDragEnd = (event: any) => {

    const state              = store.getState();
    const componentsState    = state.components;
    const setComponentsState = (payload: objType) => store.dispatch(SET_COMPONENTS_STATE(payload))

    
    if ( componentsState.success || componentsState.failurCount >= 3 ) {
        return
    }


    let payload = { 
        ...componentsState,
        draggedBox: -1,
        tens: {
            ...componentsState.tens,
            isOver: false
        },
        units: {
            ...componentsState.units,
            isOver: false
        }
    };

    if ( componentsState.tens.isOver && componentsState.draggedBox === 10 && componentsState.tens.value < 9 ) {
        payload.tens.value = Math.max(1, componentsState.tens.value + 1);
    }
    if ( componentsState.units.isOver && componentsState.draggedBox !== 10 ) {
        payload.units.value = componentsState.draggedBox;
    }

    setComponentsState(payload);
}

export default handleDragEnd